import { Typography } from '@shared/ui/typography/typography';
import { styled } from 'goober';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 20px 0;
    overflow: auto;

    & nav {
        margin: 0 20px;
    }
`;

export const HeadWrapper = styled('div')`
    display: flex;
    margin-bottom: 20px;
    padding: 0 20px;
    gap: 24px;
    flex-direction: column;
`;

export const Head = styled('div')`
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const Title = styled(Typography)`
    flex-grow: 1;
    width: 100%;
`;
